/*jshint camelcase: false */
angular
    .module('MW.ContactManager.ContactManagerActionBarFactory', [
        'MW.Framework.TranslationService',
        'MW.Framework.InfluencerContactService',
        'MW.Framework.ICMEmailService',
        'MW.Influencers.IcmDialogService',
        'MW.Framework.CoreUserService',
        'MW.ContactManager.ContactManagerOutreachComposeController',
        'MW.ContactManager.ContactManagerNavigationService',
        'Configuration'
    ])
    .factory('ContactManagerActionBarFactory', [
        'DialogService',
        'translationService',
        'InfluencerContactService',
        'CoreUserService',
        'ICMEmailService',
        '$location',
        '$controller',
        '$rootScope',
        '$q',
        'ContactManagerNavigationService',
        'EmailTemplateService',
        'ICM_ASSETS_URL',
    function(DialogService, translationService, InfluencerContactService, CoreUserService, ICMEmailService, $location, $controller, $rootScope, $q, ContactManagerNavigationService, EmailTemplateService, ICM_ASSETS_URL) {
        'use strict';
        function ContactManagerActionBarFactory(ContactSelector) {
            if(!ContactSelector) {
                return;
            }

            this.ContactSelector = ContactSelector;
            this.InfluencerContactService = InfluencerContactService;
            this.DialogService = DialogService;
            this.ICM_ASSETS_URL = ICM_ASSETS_URL;
        }

        ContactManagerActionBarFactory.prototype._exportSelectedContacts = function _exportSelectedContacts(csvFileName) {
            var exportPromise,
                contactId,
                pageSize,
                selectedContactData = {
                    ids: [],
                    emails: []
                };

            for(contactId in this.ContactSelector.selectedItems) {
                if(this.ContactSelector.selectedItems.hasOwnProperty(contactId)) {
                    if(contactId.match(/^other_contact_/)) {
                        selectedContactData.emails.push(this.ContactSelector.selectedItems[contactId].contactInfo.email[0].address);
                    } else {
                        selectedContactData.ids.push(contactId);
                    }
                }
            }

            pageSize = (selectedContactData.ids.length + selectedContactData.emails.length);
            exportPromise = this.InfluencerContactService.exportSelected(csvFileName, selectedContactData, pageSize);

            this._performExport(exportPromise);
        };

        ContactManagerActionBarFactory.prototype._performExport = function _performExport(exportPromise) {
            this.DialogService.flashInfo(translationService.getLocalizedString('Downloading the selected contacts...'));

            exportPromise.then(function() {
                this.DialogService.flashSuccess(translationService.getLocalizedString('Success. The selected contacts have been downloaded.'));
            }.bind(this)).catch(function() {
                this.DialogService.flashError(translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            }.bind(this));
        };

        ContactManagerActionBarFactory.prototype.exportContactsToCSV = function exportContactsToCSV(csvFileName, isAllContacts, selectedMediaListId, pageSize, q) {
            var exportPromise;

            if(this.ContactSelector.trueAllSelected) {
                exportPromise = this.InfluencerContactService.exportByMediaList(csvFileName, isAllContacts, selectedMediaListId, pageSize, q);

                this._performExport(exportPromise);
            } else {
                this._exportSelectedContacts(csvFileName);
            }
        };

        ContactManagerActionBarFactory.prototype.exportContactsByStatToCsv = function exportContactsByStatToCsv(csvFileName, distributionId, pageSize, statType, clickedLink) {
            var exportPromise;

            if(this.ContactSelector.trueAllSelected) {
                exportPromise = this.InfluencerContactService.exportByStat(csvFileName, distributionId, pageSize, statType, clickedLink);

                this._performExport(exportPromise);
            } else {
                this._exportSelectedContacts(csvFileName);
            }
        };

        ContactManagerActionBarFactory.prototype.exportUnsubscribedContactsToCSV = function exportUnsubscribedContactsToCSV(csvFileName, distributionId, pageSize, reason) {
            var exportPromise;

            if(this.ContactSelector.trueAllSelected) {
                exportPromise = this.InfluencerContactService.exportByUnsubscribes(csvFileName, distributionId, pageSize, reason);

                this._performExport(exportPromise);
            } else {
                this._exportSelectedContacts(csvFileName);
            }
        };

        ContactManagerActionBarFactory.prototype.compose = function compose(setRecipientsFunction, dialogMode) {
            function showUnapprovedDialog() {
                var dialogTitle = translationService.getLocalizedString('Compose Email');

                DialogService.dialog(dialogTitle,'icm-web/views/partials/email_unapproved_dialog', {}, function callback() {
                    // currently this is service is only ever called by ICM-WEB, so we always load up F-W. in this ends up being used in FW as well, we will need to revisit this logic.
                    ContactManagerNavigationService.redirectToFairhairWeb('/settings/email');
                });
            }

            function composeEmail(senderObject) {
                var dialogTitle,
                    dialogTemplate,
                    payload,
                    allTemplates,
                    customDialogCss;

                ICMEmailService.resetRecipients();

                setRecipientsFunction().then(function() {
                    ICMEmailService.setSender(senderObject);

                    if(dialogMode) {
                        let emailSetupPromises = [
                            CoreUserService.getCurrent(true),
                            EmailTemplateService.getAllTemplates()
                        ];

                        $q.all(emailSetupPromises)
                            .then(function(response){
                                if (response[1] && response[1].data && response[1].data.templates) {
                                    allTemplates = response[1].data.templates.map(function(template) {
                                        return {
                                            id: template.id,
                                            title: template.name,
                                            body: template.body
                                        };
                                    });
                                }
                                else {
                                    allTemplates = [];
                                }
                                var composeControllerScope = $rootScope.$new(),
                                    outreachComposeController = $controller('ContactManagerOutreachComposeController', {
                                        $scope: composeControllerScope,
                                        editorLanguage: response[0].language,
                                        approvedSenderArray: senderObject,
                                        sendgridDomainsArray: [],
                                        templatesList: allTemplates,
                                        dialogMode: true,
                                        loadEditorLibrary: true
                                    }),
                                    callback = function callback() {
                                        composeControllerScope.$destroy();
                                        ICMEmailService.resetRecipients();
                                    };

                                customDialogCss = {
                                    left: '50%',
                                    width: '650px'
                                };


                                dialogTitle = translationService.getLocalizedString('Compose Email');
                                dialogTemplate = 'icm-web/views/partials/outreach_compose_form';

                                payload = {
                                    outreachComposeController: outreachComposeController,
                                    wrapperTemplate: 'icm-gaf-legacy/views/partials/dialog_manager_content_scroll'
                                };

                                // load tiny v5. need to do this dynamically as we swap between v4 and v5
                                angular.element('.tinymceLib').remove();
                                var tiny5 = document.createElement('script');
                                tiny5.setAttribute('class', 'tinymceLib');
                                tiny5.setAttribute('src', `${ICM_ASSETS_URL}client/js/lib/tinymce_v5/tinymce_v5.min.js`);
                                document.head.appendChild(tiny5);

                                DialogService.dialog(dialogTitle, dialogTemplate, payload, callback, undefined, undefined, true, customDialogCss);
                            })
                            .catch(function() {
                                DialogService.flashError(translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
                            });
                    } else {
                        $location.url('/outreach/compose?step=1');
                    }
                });
            }

            ICMEmailService.getIcmApprovedSenders().then(function onGetApprovedSendersSuccess(sendersList) {
                if(sendersList.length) {
                    composeEmail(sendersList);
                } else {
                    showUnapprovedDialog();
                }
            })
            .catch(function onGetApprovedSendersFail() {
                DialogService.flashError(translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'));
            });
        };

        return ContactManagerActionBarFactory;
    }]);
